import { OnInit, EventEmitter } from '@angular/core';
import { DetailProperty } from '../objects/DetailObject';
import { DetailService } from '../services/detail.service';
import { MatTreeNestedDataSource } from '@angular/material';
import { NestedTreeControl } from '@angular/cdk/tree';
var HierarchyComponent = /** @class */ (function () {
    function HierarchyComponent(detailService) {
        this.detailService = detailService;
        this.hasCheckbox = false;
        this.fixedHeight = false;
        this.checkedItem = new EventEmitter();
        this.expandNode = new EventEmitter();
        this.onCloseHierarchy = new EventEmitter();
        this.searchHierarchy = new EventEmitter();
    }
    HierarchyComponent.prototype.ngOnInit = function () {
    };
    HierarchyComponent.prototype.closeHierarchy = function () {
        // this.detailProperty.PropertyShowHierarchy = false;
        this.onCloseHierarchy.emit(false);
    };
    HierarchyComponent.prototype.onCheckedNode = function ($event) {
        this.checkedItem.emit($event);
    };
    HierarchyComponent.prototype.onExpandNode = function ($event) {
        this.expandNode.emit($event);
    };
    HierarchyComponent.prototype.onSearchChanged = function (keyword) {
        this.searchHierarchy.emit(keyword);
    };
    return HierarchyComponent;
}());
export { HierarchyComponent };
